module.exports = __webpack_public_path__ + "static/media/strongher8.1bda97c7.jpg";